import { gql } from '../../../generated/graphql/index.js';

// Split out of sys-user-access.ts (max-lines) -- these two aren't Access-tab relation queries
// like GET_USER_ROLE_IDS/GET_USER_BRAND_IDS/GET_USER_STATE_IDS and UPDATE_USER there, they're
// the profile-fields mutation and its live-update subscription, so this is its own seam rather
// than an arbitrary split.
export const UPDATE_SYS_USER = gql(`
  mutation UpdateSysUser($id: ID!, $input: SysUserUpdateInput!) {
    updateSysUser(id: $id, input: $input) {
      id
      email
      firstName
      lastName
      phone
    }
  }
`);

export const ON_SYS_USER_CHANGED = gql(`
  subscription OnSysUserChanged($id: ID) {
    onSysUserChanged(id: $id) {
      id
      email
      firstName
      lastName
    }
  }
`);
